<template>
    <div class="container--large-content">

        <template v-if="isPageReady">

            <!-- <div class="container">
                <ul class="buttons-list buttons-list--row buttons-list--justify">
                    <li
                        v-if="iday > 1"
                        class="buttons-list__item">
                        <button
                            type="button"
                            class="button button--primary"
                            @click="$emit('previous-year')">{{ $t("previous-year") }}</button>
                    </li>
                    <li
                        v-if="iday < userAge && iday < maxIday"
                        class="buttons-list__item buttons-list__item--end">
                        <button
                            type="button"
                            class="button button--primary"
                            @click="$emit('next-year')">{{ $t("next-year") }}</button>
                    </li>
                </ul>
            </div>
 -->
            <div class="container">
                <section class="barometer-section">
                    <h2>{{ $t("what-append-x-year", {x: iday}) }}</h2>
                </section>
            </div>

            <div v-if="events && monthCycle && monthCycle.length > 0">
                <section
                    class="barometer-section">
                    <div class="container">
                        <h2>{{ $t("cycle-month-title") }}</h2>
                        <p
                            class="page__subtitle"
                            v-html="$t('cycle-month-subtitle')"></p>
                    </div>

                    <year-detail-chart
                        :data="monthCycle"
                        @show-domain-modal="showDomainModal"
                        :events="events"
                        :iday="iday"
                        :user-birthdate="user.bdate"
                        @prev-year="prevYear"
                        @nxt-year="nxtYear"
                        :i-day="iday"
                        :max-iday="maxIday"
                        :user-age="userAge" />
                </section>

                <!-- <div class="monthly-btn">
                    <ul class="buttons-list buttons-list--row buttons-list--justify">
                        <li
                            v-if="iday > 1"
                            class="buttons-list__item">
                            <svg
                                @click="$emit('previous-year')"
                                width="24"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#f586cb"
                                fill-rule="evenodd"
                                cursor="pointer"
                                clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                        </li>
                        <li
                            v-if="iday < userAge && iday < maxIday"
                            class="buttons-list__item buttons-list__item--end">
                            <svg
                                @click="$emit('next-year')"
                                width="24"
                                height="24"
                                fill="#f586cb"
                                cursor="pointer"
                                xmlns="http://www.w3.org/2000/svg"
                                fill-rule="evenodd"
                                clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div style="margin-top: 300px;"></div>
            <div
                v-if="events && (eclipseCycle && eclipseCycle.length > 0)">
                <section
                    class="barometer-section">
                    <div class="container">
                        <h2>{{ $t("cycle-eclipse-title", {x: iday}) }}</h2>
                        <p
                            class="page__subtitle"
                            v-html="$t('cycle-eclipse-subtitle')"></p>
                    </div>

                    <year-detail-chart
                        :data="eclipseCycle"
                        @show-domain-modal="showDomainModal"
                        :events="events"
                        :iday="iday"
                        :user-birthdate="user.bdate"
                        @prev-year="prevYear"
                        @nxt-year="nxtYear"
                        :i-day="iday"
                        :max-iday="maxIday"
                        :user-age="userAge" />
                    <!-- <div class="ecl-btn">
                        <ul class="buttons-list buttons-list--row buttons-list--justify">
                            <li
                                v-if="iday > 1"
                                class="buttons-list__item">
                                <svg
                                    @click="$emit('previous-year')"
                                    width="24"
                                    height="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#f586cb"
                                    fill-rule="evenodd"
                                    cursor="pointer"
                                    clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                            </li>
                            <li
                                v-if="iday < userAge && iday < maxIday"
                                class="buttons-list__item buttons-list__item--end">
                                <svg
                                    @click="$emit('next-year')"
                                    width="24"
                                    height="24"
                                    fill="#f586cb"
                                    cursor="pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                            </li>
                        </ul>
                    </div> -->
                </section>
            </div>
            <div style="margin-top: 300px;"></div>
            <section class="barometer-section">
                <div class="container">
                    <h2>{{ $t("cycle-year-title", {x: iday}) }} </h2>
                    <p
                        class="page__subtitle"
                        v-html="$t('cycle-year-subtitle')"></p>
                </div>

                <template v-if="loggedUser.userpremium === true">
                    <div
                        v-if="yearDomain"
                        class="container">
                        <div class="year-domains">
                            <div
                                v-if="yearDomain.couleur"
                                class="year-domain year-domain--flower-01">
                                <button
                                    type="button"
                                    class="trait-circle button--trait-circle button--transparent"
                                    :style="{backgroundColor: '#' + yearDomain.couleur.toLowerCase()}"
                                    @click="showDomainModal(yearDomain.domaine.toLowerCase())">
                                    <span class="year-domain__label">{{ $t(yearDomain.domaine + "-barometer") }}
                                        <span
                                            v-if="yearDomain.scale"
                                            class="year-domain__scale">{{ yearDomain.scale }}</span>
                                        <span
                                            v-if="yearDomainPlanet"
                                            class="year-domain__scale year-domain__scale--zodiac">
                                            <img
                                                v-for="(sign, index) in yearDomainPlanet"
                                                :key="'sign-' + index"
                                                class="year-domain__scale-sign"
                                                :class="(index === 0) ? 'color-filter--ffffff' : false"
                                                :src="require('@/assets/images/icons/zodiac/' + sign + '.svg')"
                                                :alt="$t(sign)"
                                                :title="$t(sign)" />
                                        </span>
                                    </span>
                                </button>
                                <img
                                    class="year-domain__artwork"
                                    :class="'color-filter--' + yearDomain.couleur.toLowerCase()"
                                    src="@/assets/images/artworks/year-domains/flower-01.svg"
                                    alt="" />
                            </div>
                            <div
                                v-if="yearDomain.couleur_2"
                                class="year-domain year-domain--flower-02">
                                <button
                                    type="button"
                                    class="trait-circle button--trait-circle button--transparent"
                                    :style="{backgroundColor: '#' + yearDomain.couleur_2.toLowerCase()}"
                                    @click="showDomainModal(yearDomain.domaine_2.toLowerCase())">
                                    <span class="year-domain__label">{{ $t(yearDomain.domaine_2 + "-barometer") }}
                                        <span
                                            v-if="yearDomain.scale_2"
                                            class="year-domain__scale">{{ yearDomain.scale_2 }}</span>
                                        <span
                                            v-if="yearDomainPlanet2"
                                            class="year-domain__scale year-domain__scale--zodiac">
                                            <img
                                                v-for="(sign, index) in yearDomainPlanet2"
                                                :key="'sign-' + index"
                                                class="year-domain__scale-sign"
                                                :class="(index === 0) ? 'color-filter--ffffff' : false"
                                                :src="require('@/assets/images/icons/zodiac/' + sign + '.svg')"
                                                :alt="$t(sign)"
                                                :title="$t(sign)" />
                                        </span>
                                    </span>
                                </button>
                                <img
                                    class="year-domain__artwork"
                                    :class="'color-filter--' + yearDomain.couleur_2.toLowerCase()"
                                    src="@/assets/images/artworks/year-domains/flower-02.svg"
                                    alt="" />
                            </div>
                            <div
                                v-if="yearDomain.couleur_3"
                                class="year-domain year-domain--flower-03">
                                <button
                                    type="button"
                                    class="trait-circle button--trait-circle button--transparent"
                                    :style="{backgroundColor: '#' + yearDomain.couleur_3.toLowerCase()}"
                                    @click="showDomainModal(yearDomain.domaine_3.toLowerCase())">
                                    <span class="year-domain__label">{{ $t(yearDomain.domaine_3 + "-barometer") }}
                                        <span
                                            v-if="yearDomain.scale_3"
                                            class="year-domain__scale">{{ yearDomain.scale }}</span>
                                        <span
                                            v-if="yearDomainPlanet3"
                                            class="year-domain__scale year-domain__scale--zodiac">
                                            <img
                                                v-for="(sign, index) in yearDomainPlanet3"
                                                :key="'sign-' + index"
                                                class="year-domain__scale-sign"
                                                :class="(index === 0) ? 'color-filter--ffffff' : false"
                                                :src="require('@/assets/images/icons/zodiac/' + sign + '.svg')"
                                                :alt="$t(sign)"
                                                :title="$t(sign)" />
                                        </span>
                                    </span>
                                </button>
                                <img
                                    class="year-domain__artwork"
                                    :class="'color-filter--' + yearDomain.couleur_3.toLowerCase()"
                                    src="@/assets/images/artworks/year-domains/flower-03.svg"
                                    alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="ecl-btn">
                        <ul class="buttons-list buttons-list--row buttons-list--justify">
                            <li
                                v-if="iday > 1"
                                class="buttons-list__item">
                                <svg
                                    @click="$emit('previous-year')"
                                    width="24"
                                    height="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#f586cb"
                                    fill-rule="evenodd"
                                    cursor="pointer"
                                    clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                            </li>
                            <li
                                v-if="iday < userAge && iday < maxIday"
                                class="buttons-list__item buttons-list__item--end">
                                <svg
                                    @click="$emit('next-year')"
                                    width="24"
                                    height="24"
                                    fill="#f586cb"
                                    cursor="pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                            </li>
                        </ul>
                    </div>
                </template>
                <template v-else>
                    <PlaceholderPremiumOnly></placeholderpremiumonly>
                    <div class="ecl-btn">
                        <ul class="buttons-list buttons-list--row buttons-list--justify">
                            <li
                                v-if="iday > 1"
                                class="buttons-list__item">
                                <svg
                                    @click="$emit('previous-year')"
                                    width="24"
                                    height="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#f586cb"
                                    fill-rule="evenodd"
                                    cursor="pointer"
                                    clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                            </li>
                            <li
                                v-if="iday < userAge && iday < maxIday"
                                class="buttons-list__item buttons-list__item--end">
                                <svg
                                    @click="$emit('next-year')"
                                    width="24"
                                    height="24"
                                    fill="#f586cb"
                                    cursor="pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                            </li>
                        </ul>
                    </div>
                </template>

                <!-- <div class="container">
                    <ul class="buttons-list buttons-list--row buttons-list--justify">
                        <li
                            v-if="iday > 1"
                            class="buttons-list__item">
                            <button
                                type="button"
                                class="button button--primary"
                                @click="$emit('previous-year')">{{ $t("previous-year") }}</button>
                        </li>
                        <li
                            v-if="iday < userAge && iday < maxIday"
                            class="buttons-list__item buttons-list__item--end">
                            <button
                                type="button"
                                class="button button--primary"
                                @click="$emit('next-year')">{{ $t("next-year") }}</button>
                        </li>
                    </ul>
                </div> -->

            </section>
            <div style="margin-top: 300px;"></div>

            <section class="barometer-section">
                <div class="container">
                    <h2>{{ $t("cycle-title-luck", {x: iday}) }}</h2>
                    <p
                        class="page__subtitle"
                        v-html="$t('cycle-subtitle-luck')"></p>
                </div>

                <template v-if="loggedUser.userpremium === true">
                    <period-chart
                        v-if="yearCycle"
                        :data="yearCycle"
                        :min-height="1000"
                        @prev-year="prevYear"
                        @nxt-year="nxtYear"
                        :i-day="iday"
                        :max-iday="maxIday"
                        :user-age="userAge" />
                </template>
                <template v-else>
                    <PlaceholderPremiumOnly></placeholderpremiumonly>
                    <div class="ecl-btn">
                        <ul class="buttons-list buttons-list--row buttons-list--justify">
                            <li
                                v-if="iday > 1"
                                class="buttons-list__item">
                                <svg
                                    @click="$emit('previous-year')"
                                    width="24"
                                    height="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#f586cb"
                                    fill-rule="evenodd"
                                    cursor="pointer"
                                    clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                            </li>
                            <li
                                v-if="iday < userAge && iday < maxIday"
                                class="buttons-list__item buttons-list__item--end">
                                <svg
                                    @click="$emit('next-year')"
                                    width="24"
                                    height="24"
                                    fill="#f586cb"
                                    cursor="pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                            </li>
                        </ul>
                    </div>
                </template>
            </section>
        </template>
        <template v-else>
            <div class="loader">
                <HorizontalBubbleLoader />
            </div>
        </template>



        <domain-detail-modal
            v-if="isDomainModalVisible"
            :current-domain-detail="currentDomainDetail"
            @closeModal="isDomainModalVisible = false" />
    </div>
</template>

<script>
// @ is an alias to /src

import YearDetailChart from "@/components/charts/YearsDetailChart.vue";
import PeriodChart from "@/components/charts/PeriodChart.vue";

import DomainDetailModal from "@/components/modals/domains/DomainDetailModal.vue";
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";
import PlaceholderPremiumOnly from "@/components/placeholder/PlaceholderPremiumOnly.vue";

import { getEventAll } from "@/utils/api/usersApi.js";

import dayjs from "dayjs";

export default {
    name: "CycleYear",
    components: {
        "DomainDetailModal": DomainDetailModal,
        "YearDetailChart": YearDetailChart,
        "HorizontalBubbleLoader": HorizontalBubbleLoader,
        "PeriodChart": PeriodChart,
        "PlaceholderPremiumOnly": PlaceholderPremiumOnly
    },
    props: {
        cycle: {
            type: Array,
            required: true
        },
        iday: {
            type: Number,
            required: true
        },
        userId: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        domain: {
            type: String,
            required: true
        },
        maxIday: {
            type: Number,
            required: false,
            default: 99
        }
    },
    data() {
        return {
            currentDomainDetail: null,
            isDomainModalVisible: false,
            events: null
        };
    },
    computed: {
        yearDomain() {
            return this.cycle.find((item) => {
                return item.report_name === "month" && item.rs === 1 && item.iday === String(this.iday);
            });
        },
        yearDomainPlanet () {
            if (this.yearDomain && this.yearDomain.planet) {
                const array = this.yearDomain.planet.split(",");

                const arrayToLowerCase = array.map((item) => {
                    return item.toLowerCase();
                });

                return arrayToLowerCase;
            }
        },
        yearDomainPlanet2 () {
            if (this.yearDomain && this.yearDomain.planet_2) {
                const array = this.yearDomain.planet_2.split(",");

                const arrayToLowerCase = array.map((item) => {
                    return item.toLowerCase();
                });

                return arrayToLowerCase;
            }
        },
        yearDomainPlanet3 () {
            if (this.yearDomain && this.yearDomain.planet_3) {
                const array = this.yearDomain.planet_3.split(",");

                const arrayToLowerCase = array.map((item) => {
                    return item.toLowerCase();
                });

                return arrayToLowerCase;
            }
        },
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        userAge() {
            const birthdate = dayjs(this.user.bdate);
            return dayjs().diff(birthdate, "year");
        },
        monthCycle() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.report_name === "month" && item.iday === String(this.iday) && item.score > 0;
                });
            }
        },
        eclipseCycle() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.report_name === "eclipse" && item.iday === String(this.iday) && item.score > 0;
                });
            }
        },
        yearCycle() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    const itemIday = item.iday;

                    if (item.report_name === "year") {
                        return itemIday === String(this.iday);
                    }

                });
            }
        },
        isPageReady() {
            // console.log("events:", this.events);
            // console.log("monthCycle:", this.monthCycle);
            // console.log("monthCycle length:", this.monthCycle.length);
            // console.log("eclipseCycle:", this.eclipseCycle);
            // console.log("eclipseCycle length:", this.eclipseCycle.length);

            if (this.events && this.monthCycle && this.monthCycle.length && (this.eclipseCycle && this.eclipseCycle.length > 0)) {
                return true;
            }

            return true;
        }
    },
    mounted: function() {
        // console.log("year chart enter");
        this.fetchEvents();
    },
    methods: {
        prevYear() {
            this.$emit("previous-year");
        },
        nxtYear() {
            this.$emit("next-year");
        },
        showDomainModal(value) {
            this.currentDomainDetail = {
                "title": this.$t(value + "-barometer"),
                "description": this.$t("domain-" + value)
            };

            this.isDomainModalVisible = true;
        },
        fetchEvents() {
            // console.log("fetch event function call");
            // Fetch events
            const user = {
                "id_user": this.loggedUser.id_person,
                "id_person": this.user.id_person
            };
            // console.log("user:",user);

            getEventAll(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.events = res.data.part1;
                    // console.log(this.events);
                } else {
                    // Handle Error
                    this.events = [];
                }
            });
        },
    }
};
</script>
<style scoped>
.ecl-btn {
    margin-top: -210px;
    margin-left: 50px;
    margin-right: 50px;
}
.monthly-btn {
    margin-top: -310px;
    margin-left: 50px;
    margin-right: 50px;
}
.transit-btn {
    margin-top: -1370px;
    margin-left: 50px;
    margin-right: 50px;
}
</style>
